import App from '../../App/App.js';
import Router from "../../App/Router";
import LangSwitcher from "../../Header/LangSwitcher/LangSwitcher";

const Page = {
    url: null,

    init() {
        this.el = $('[component="Page"]');
    },

    setByUrl(url) {
        // console.log('Page.setByUrl()', url, typeof this.url)

        // reload - first time run - do nothing
        if (!this.url && this.url !== '') {
            this.url = url;
            return;
        }

        // same url - do nothing
        if (this.url === url) return;

        // different url - load Page
        console.log('****** PAGE redirect ***********')
        window.location.href = Router.url;
    },

}

export default Page;
